import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { toast } from 'react-toastify';
import {getPrenotazioni, deletePrenotazione} from './api/api.private.service';
import { getMediaLink } from './api/utils';

const MyBookingsPage = () => {
  const [bookings, setBookings] = useState([]);
  const [sessionDetails, setSessionDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
      const fetchPrenotazioni = async () => {
        try {
          const data = await getPrenotazioni();
          setBookings(data.data);
        } catch (error) {
          console.error('Error fetching prenotazioni:', error);
        }
      };
  
      fetchPrenotazioni();
    }, []);

  const handleAccessLab = (booking) => {
    setSessionDetails({
      labName: booking.esperimenti.laboratorio.nome,
      expirementTitle:  booking.esperimenti.titolo,
      startTime: formatDate(booking.data) + ' ' + booking.slots[0].split(' - ')[0],
      duration: (60*booking.slots.length) + ' minuti',
      link: booking.link
    });
    setShowModal(true);
  };

  const handleDeleteBooking = async (bookingId) => {
    const answer = window.confirm('Sei sicuro? L\'operazione è irreversibile.');
    if(answer) {
        try {
            const response = await deletePrenotazione(bookingId);
            if(response) {
                toast('Prenotazione eliminata.', {type: 'success'});
                window.location.reload();
            } else {
                toast('Operazione fallita.', {type: 'error'});
            }
        } catch (error) {
            toast('Operazione fallita.', {type: 'error'});
        }
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT');
  };

  return (
    <div className="min-h-screen">
      <Navbar />
        <section
          className="text-center py-20"
          style={{
            backgroundImage: 'url("/header.png")',
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
          }}
        >
          <h2 className="text-4xl font-extrabold text-gray-800 font-space bg-white bg-opacity-75 inline-block px-4 py-2">
            [ Prenotazioni ]
          </h2>
        </section>
        <div className="max-w-4xl mx-auto bg-white">
          {bookings.map((booking, index) => (
              <div className="flex flex-col mt-12 p-6 shadow-md">
                <div key={index} className="mb-6 flex flex-col md:flex-row w-full justify-between">
                  <div>
                    <small className="text-xs uppercase font-semibold text-gray-400">Esperimento</small>
                    <h2 className="text-2xl font-bold text-gray-800">{booking.esperimenti.titolo}</h2>
                    <img
                      src={getMediaLink(booking.esperimenti.immagine?.url)}
                      className="w-32 object-cover mr-4"
                      alt={booking.esperimenti.titolo}
                    />
                  </div>
                  <div className="mt-12 md:mt-0">
                    <small className="text-xs uppercase font-semibold text-gray-400">Laboratorio</small>
                    <h2 className="text-2xl font-bold text-gray-800">{booking.esperimenti.laboratorio.nome}</h2>
                    <img
                        src={getMediaLink(booking.esperimenti.laboratorio.immagine?.url)}
                        className=""
                        width={'300px'}
                        alt={booking.esperimenti.laboratorio.nome}
                      />
                  </div>
                </div>
                <div className="mb-6 flex flex-col md:flex-row w-full justify-evenly">
                  <div>
                    <small className="text-xs uppercase font-semibold text-gray-400">Data prenotazione</small>
                    <h3 className="text-xl font-semibold text-gray-800">{formatDate(booking.data)}</h3>
                  </div>
                  <div>
                    <small className="text-xs uppercase font-semibold text-gray-400 mt-4">Slot prenotati</small>
                    <ul className="text-gray-700">
                      {booking.slots.map((slot, slotIndex) => (
                        <li key={slotIndex} className="text-xl font-semibold text-gray-800">{slot}</li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <small className="text-xs uppercase font-semibold text-gray-400">Stato</small>
                    {booking.stato === 'CANCELED' && <h3 className="text-md font-semibold text-white bg-red-600 rounded-full pt-1 pb-1 pr-4 pl-4">Annullata</h3>}
                    {booking.stato === 'CONFIRMED' && <h3 className="text-md font-semibold text-white bg-green-600 rounded-full pt-1 pb-1 pr-4 pl-4">Confermata</h3>}
                    {booking.stato === 'PENDING' && <h3 className="text-md font-semibold text-white bg-blue-600 rounded-full pt-1 pb-1 pr-4 pl-4">In attesa</h3>}
                    {!booking.stato && <h3 className="text-md font-semibold text-white bg-gray-600 rounded-full pt-1 pb-1 pr-4 pl-4">Non definito</h3>}
                  </div>
                </div>
                <div className="flex space-x-4 mt-4">
                    <button
                      onClick={() => handleAccessLab(booking)}
                      disabled={booking.stato !== 'CONFIRMED'}
                      className={`flex-1 text-center mt-6 block text-center px-4 py-2 shadow-md uppercase text-sm font-semibold ${
                        booking.stato !== 'CONFIRMED'
                          ? 'bg-gray-300 text-gray-500 border-2 border-gray-300 cursor-not-allowed'
                          : 'bg-white text-black border-2 border-black hover:bg-black hover:text-white'
                      }`}
                    >
                      <i className="fas fa-door-open mr-2"></i> Accedi al laboratorio
                    </button>
                    <button
                      onClick={() => handleDeleteBooking(booking.documentId)}
                      disabled={booking.stato === 'CONFIRMED' || booking.stato === 'CANCELED'}
                      className={`mt-6 block text-center px-4 py-2 shadow-md uppercase text-sm font-semibold ${
                        booking.stato === 'CONFIRMED' || booking.stato === 'CANCELED'
                          ? 'bg-gray-300 text-gray-500 border-2 border-gray-300 cursor-not-allowed'
                          : 'bg-white text-black border-2 border-black hover:bg-black hover:text-white'
                      }`}
                    >
                      <i className="fas fa-trash-alt mr-2"></i> Elimina
                    </button>
                  </div>
            </div>
          ))}
        </div>
      <Footer />

      {showModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center" style={{zIndex: 999}}>
          <div className="bg-white p-6 shadow-lg max-w-md w-full">
            <h2 className="text-2xl font-bold mb-4">Riepilogo della sessione</h2>
            <p><strong>Laboratorio:</strong> {sessionDetails.labName}</p>
            <p><strong>Esperimento:</strong> {sessionDetails.expirementTitle}</p>
            <p><strong>Inizio:</strong> {sessionDetails.startTime}</p>
            <p><strong>Durata:</strong> {sessionDetails.duration}</p>
            <div className="mt-4 flex justify-end">
              <a href={sessionDetails.link} target="_blank" className="mt-6 block text-center px-4 py-2 shadow-md bg-white text-black border-2 border-black hover:bg-black hover:text-white uppercase text-sm font-semibold">Inizia sessione</a>
              <button onClick={() => setShowModal(false)} className="mt-6 block text-center px-4 py-2 shadow-md bg-white text-black border-2 border-black hover:bg-black hover:text-white ml-4 uppercase text-sm font-semibold">Chiudi</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyBookingsPage;